export const possTranslations = {
  ru: {
    backToProducts: "Назад к продуктам",
    ourProducts: "Наши продукты",
    requestDemo: "Запросить демо",
    downloadPresentation: "Скачать презентацию",
    keyFeatures: "Ключевые возможности",
    benefits: "Преимущества",
    forWhom: "Для кого подходит",
    forWhomDescription: "POSS эффективно решает задачи управления запасами для различных типов бизнеса",
    readyToTry: "Готовы попробовать?",
    readyToTryDescription: "Наша команда готова провести демонстрацию продукта и ответить на все ваши вопросы. Получите персональную консультацию уже сегодня.",
    requestDemoCTA: "Запросить демо",
    contactUs: "Связаться с нами",
    freeConsultation: "Бесплатная консультация",
    freeConsultationDescription: "Получите экспертную консультацию по внедрению в ваш бизнес"
  },
  en: {
    backToProducts: "Back to Products",
    ourProducts: "Our Products",
    requestDemo: "Request Demo",
    downloadPresentation: "Download Presentation",
    keyFeatures: "Key Features",
    benefits: "Benefits",
    forWhom: "How you sell matters",
    forWhomDescription: "POSS effectively solves retail process management tasks for various types of businesses",
    readyToTry: "Ready to add value to your business?",
    readyToTryDescription: "Request for demo, special offers and early access to new features.",
    requestDemoCTA: "Request Demo",
    contactUs: "Contact Us",
    freeConsultation: "Free Consultation",
    freeConsultationDescription: "Get expert consultation on implementing POSS in your business"
  }
} as const; 